"use client";

import { c as _c } from "react/compiler-runtime";
import { useT } from "@/lib/i18n";
import { useFlairFor, type SubscriberTier } from "@/lib/supporter-flair";
import { accentFor } from "@/lib/theme-palette";
import { useViewerMode } from "./useViewerMode";
export function SupporterBadge(t0) {
  const $ = _c(15);
  const {
    theme,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t = useT();
  const mode = useViewerMode();
  if (!theme) {
    return null;
  }
  let t2;
  if ($[0] !== mode || $[1] !== theme) {
    t2 = accentFor(theme, mode);
    $[0] = mode;
    $[1] = theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const color = t2;
  if (!color) {
    return null;
  }
  const t3 = `inline-flex items-center rounded-full border px-1.5 py-px align-middle text-[0.6rem] font-semibold uppercase leading-tight tracking-wider whitespace-nowrap ${className}`;
  const t4 = `color-mix(in srgb, ${color} 14%, transparent)`;
  let t5;
  if ($[3] !== color || $[4] !== t4) {
    t5 = {
      color,
      borderColor: color,
      backgroundColor: t4
    };
    $[3] = color;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("Supporter");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t("Supporter");
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <span className={t3} style={t5} title={t6}>{t7}</span>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
const TIER_STYLE: Record<SubscriberTier, {
  label: string;
  color: string;
}> = {
  common: {
    label: "Common Subscriber",
    color: "var(--sub-common)"
  },
  rare: {
    label: "Rare Subscriber",
    color: "var(--sub-rare)"
  },
  ancient: {
    label: "Ancient Subscriber",
    color: "var(--sub-ancient)"
  }
};
export function TierBadge(t0) {
  const $ = _c(14);
  const {
    tier,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t = useT();
  const {
    label,
    color
  } = TIER_STYLE[tier];
  const t2 = `inline-flex items-center rounded-full border px-1.5 py-px align-middle text-[0.6rem] font-semibold uppercase leading-tight tracking-wider whitespace-nowrap ${className}`;
  const t3 = `color-mix(in srgb, ${color} 14%, transparent)`;
  let t4;
  if ($[0] !== color || $[1] !== t3) {
    t4 = {
      color,
      borderColor: color,
      backgroundColor: t3
    };
    $[0] = color;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== label || $[4] !== t) {
    t5 = t(label);
    $[3] = label;
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== label || $[7] !== t) {
    t6 = t(label);
    $[6] = label;
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <span className={t2} style={t4} title={t5}>{t6}</span>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
export function PlayerBadge(t0) {
  const $ = _c(6);
  const {
    username,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const flair = useFlairFor(username);
  if (flair?.tier) {
    let t2;
    if ($[0] !== className || $[1] !== flair.tier) {
      t2 = <TierBadge tier={flair.tier} className={className} />;
      $[0] = className;
      $[1] = flair.tier;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t2 = flair?.theme;
  let t3;
  if ($[3] !== className || $[4] !== t2) {
    t3 = <SupporterBadge theme={t2} className={className} />;
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}